import { createAction } from 'redux-actions';
import storage from 'util/storage';

export const resizeWindow = createAction('RESIZE_WINDOW', (width, height) => ({ width, height }));

export const scrollWindow = createAction('SCROLL_WINDOW', scrollY => ({ scrollY }));

export const matchMedia = createAction('MATCH_MEDIA', media => ({ media }));

export const loadConfig = createAction('LOAD_CONFIG', config => config);

export const loadedLibrary = createAction('LOAD_LIBRARY', lib => ({ lib }));

// 處理頁面 lazy loading
export const pageLoading = createAction('PAGE_LOADING', page => ({ page }));

export const pageLoaded = createAction('PAGE_LOADED', page => ({ page }));

export const pageEntering = createAction('PAGE_ENTERING', page => ({ page }));

export const pageEntered = createAction('PAGE_ENTERED', page => ({ page }));

export const pageChanging = createAction('PAGE_CHANGING', page => ({ page }));

export const pageChanged = createAction('PAGE_CHANGED', page => ({ page }));

export const loadingRatio = createAction('LOADING_RATIO', (ratio, page) => ({ ratio, page }));

export const updateOffsetTop = createAction('UPDATE_OFFSET_TOP', (page, section, offsetTop) => ({
	page,
	section,
	offsetTop,
}));

export const agreeCookie = createAction('AGREE_COOKIE', () => {
	storage.setItem('cookie', JSON.stringify({ display: false }));
});



// WEBPACK FOOTER //
// ./src/actions/global.js